import { DimensionServiceAckResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { DimensionServiceService } from './dimension-service.service';
import { DimensionDTO } from './dto/dimension.dto';

@ApiTags('dimension-service')
@Controller('dimension')
export class DimensionServiceController {
    constructor(private dimensionService: DimensionServiceService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

        
    /**
     * calling a service to create a new dimension
     * @param dimensionDto 
     * @returns 
     */
    @Post('/createDimension')
    async createDimension(@Body() dimensionDto: DimensionDTO): Promise<DimensionServiceAckResponse>  {
        try {
            return await this.dimensionService.createDimension(dimensionDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(DimensionServiceAckResponse, error);
        }
    }

    /**
     * calling a service to dimensions list
     * @returns 
     */
    @Post('getDimensions')
    async getDimensions():Promise<DimensionServiceAckResponse> {
        try {
            return await this.dimensionService.getDimensions();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(DimensionServiceAckResponse, error);
        }
    }

    /**
     * calling a service to dimensions list by plant id
     * @param plantIdReq
     * @returns 
     */
     @Post('getDimensionsByPlantId')
     async getDimensionsByPlantId(@Body() plantIdReq: PlantIdRequest):Promise<DimensionServiceAckResponse> {
         try {
             return await this.dimensionService.getDimensionsByPlantId(plantIdReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(DimensionServiceAckResponse, error);
         }
     }
}
